import React from 'react'
import CurrencyDisplay from '../shared/CurrencyDisplay'

interface KPICardProps {
  title: string
  iconSvg: string
  number: string | number
  text: string
  textIcon?: string
  height?: number
  width?: number
  left?: number
  right?: number
}

const KPICard: React.FC<KPICardProps> = ({
  title,
  iconSvg,
  number,
  text,
  textIcon = '',
  height,
  width,
  left = 0,
  right = 0,
}) => {
  return (
    <div
      className="bg-white rounded-[15px] flex items-center justify-between px-4 py-3"
      style={{
        height: height ? `${height}px` : 'auto',
        marginLeft: `${left}px`,
        marginRight: `${right}px`,
        marginTop: '15px',
        marginBottom: '15px',
      }}
    >
      {/* Icon and title row (left side) */}
      <div className="flex items-center gap-2">
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: '#F5F5F5' }}
        >
          <img
            src={iconSvg}
            alt={title}
            className="w-[25px] h-[25px]"
            style={{
              filter: 'brightness(0) saturate(100%)',
            }}
          />
        </div>
        <span className="font-medium font-['IBM_Plex_Sans_Arabic'] text-base text-black">
          {title}
        </span>
      </div>

      {/* Number and text row (right side) */}
      <div className="flex items-center gap-1">
        <span
          className="font-normal font-['IBM_Plex_Sans_Arabic'] text-xl text-black"
          dir="ltr"
        >
          {number}
        </span>
        {text && (
          <span className="font-normal font-['IBM_Plex_Sans_Arabic'] text-xs text-black">
            {text}
          </span>
        )}
        {textIcon && (
          <CurrencyDisplay
            className="w-[18px] h-[18px]"
            iconStyle={{ width: width || 18, height: height || 18 }}
          />
        )}
      </div>
    </div>
  )
}

export default KPICard
